import { Switch, Route, Redirect, useHistory } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import BackofficePage from './page/Backoffice'
import CoreHeader from './component/backoffice/CoreHeader'
import CoreFooter from './component/backoffice/CoreFooter'
import LayoutBackoffice from './component/backoffice/Layout'
import ManageUserGroup from './component/backoffice/ManageUserGroup'
import ManageUserGroupForm from './component/backoffice/ManageUserGroupForm'
import ManageUser from './component/backoffice/ManageUser'
import ManageUserForm from './component/backoffice/ManageUserForm'
import ManageContent from './component/backoffice/ManageContent'
import ManageContentForm from './component/backoffice/ManageContentForm'
import ManageContact from './component/backoffice/ManageContact'
import ManageMux from './component/backoffice/ManageMux'
import ManageMuxForm from './component/backoffice/ManageMuxForm'
import Scrollbar from './control/Scrollbar'
import { useEffect } from 'react'

const MainBackoffice = () => {
    const history = useHistory()

    useEffect(() => {
        let localRefId = globalThis.sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)

        if (!localRefId) {
            localRefId = globalThis.localStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
        }

        if (!localRefId) {
            globalThis.sessionStorage.clear()
            globalThis.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
            history.push('/')
        }
    }, [])

    return (
        <Root>
            <CoreHeader />
            <Content>
                <div style={{ width: '100%', height: '100%' }}>
                    <Scrollbar scrollbarTrackBorderRadius={10} scrollbarThumbBorderRadius={10}>
                        <LayoutBackoffice>
                            <Switch>
                                <Route exact path="/backoffice/usergroup-management/add">
                                    <ManageUserGroupForm type="add" />
                                </Route>
                                <Route exact path="/backoffice/usergroup-management/:id/edit">
                                    <ManageUserGroupForm type="edit" />
                                </Route>
                                <Route exact path="/backoffice/usergroup-management">
                                    <ManageUserGroup />
                                </Route>
                                <Route exact path="/backoffice/user-management/add">
                                    <ManageUserForm type="add" />
                                </Route>
                                <Route exact path="/backoffice/user-management/:id/edit">
                                    <ManageUserForm type="edit" />
                                </Route>
                                <Route exact path="/backoffice/user-management">
                                    <ManageUser />
                                </Route>
                                <Route exact path="/backoffice/content-management/:name/edit">
                                    <ManageContentForm />
                                </Route>
                                <Route exact path="/backoffice/content-management">
                                    <ManageContent />
                                </Route>
                                <Route exact path="/backoffice/contact-management">
                                    <ManageContact />
                                </Route>
                                <Route exact path="/backoffice/mux-management">
                                    <ManageMux />
                                </Route>
                                <Route exact path="/backoffice/mux-management/:id/edit">
                                    <ManageMuxForm />
                                </Route>
                                <Route exact path="/backoffice">
                                    <BackofficePage />
                                </Route>
                                <Redirect to="/not-found" />
                            </Switch>
                        </LayoutBackoffice>
                    </Scrollbar>
                </div>
            </Content>
            <CoreFooter />
        </Root>
    )
}

const Root = styled('div')(({ theme }) => ({
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: `${theme.palette.getContrastText('bg-backoffice')}`,
}))

const Content = styled('div')(({ theme }) => ({
    marginTop: '70px',
    height: `calc(100% - 92px)`,
}))

export default MainBackoffice
